<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">典型案例详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="典型案例名称" prop="DocumentName">
                <el-input
                  v-model="data.DocumentName"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发生地点" prop="HappenAddress">
                <el-input
                  v-model="data.HappenAddress"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="发生时间" prop="HappenTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.HappenTime"
                  format="yyyy-MM-dd"
                  :disabled="!IsEdit"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="附件上传" ref="File" prop="UploadDataId">
                <el-upload
                  class="upload-demo"
                  ref="uploadFile"
                  accept=".pdf, .doc, .docx"
                  :http-request="uploadAttchFile"
                  :show-file-list="true"
                  :file-list="fileList"
                  :on-success="uploadsuccess"
                  :on-progress="uploadProgress"
                  :on-error="uploadError"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  action="#"
                >
                  <el-button size="mini" style="width: 8rem" v-if="IsEdit"
                    >上传</el-button
                  >
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="center" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
import Apis from "../../../../../../api";
const utils = ZJApp.ZJUtils;

export default {
  name: "ClassicCaseInfo",
  controller: "UI",
  action: "ClassicCaseInfo",
  data() {
    return {
      data: {
        UploadDataId: null,
        HappenTime: null,
      },

      loading: false,
      loadingText: "加载中...",
      IsEdit: false,
      rules: {
        DocumentName: [
          { required: true, message: "请输入案例名称", trigger: "blur" },
        ],
      },
      uploadData: {
        module: "EmergrncyFiles", //模块名
        submodule: "", //子模块
        assocID: "", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0, //扩展字段 3
      },
      fileList: [],
      uploadFileList: [],
      fileId: "",
      uuid:
        this.$route.query.type == "edit"
          ? this.$route.query.InfoId
          : ZJApp.ZJUtils.uuid(),
      delFileList: [],
    };
  },
  created: function () {
    if (this.$route.query.InfoId) {
      this.search();
      this.getFileList();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.getFileList();
        this.search();
      }
    },
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  methods: {
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        this.loading = true;
        new MyApis.DocumentApi()
          .GeItemById({ Id: InfoId })
          .then((r) => {
            r = r.data.Data;
            this.data = r;
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //获取上传附件
    getFileList() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        const searchInfo = { AssocID: InfoId, PageSize: 10, PageIndex: 1 };
        this.loading = true;
        new Apis.FileApi()
          .GetFileList(searchInfo)
          .then((r) => {
            r = r.data.Data;
            // this.fileList = r.FileList.map((item) => ({
            //   name: item.FileName,
            //   url: item.DownloadPath + "?d=1",
            // }));
            this.fileList = r.FileList;
            this.fileList.forEach((item) => {
              item.url = item.DownloadPath+ "?d=1";
              item.name = item.FileName;
            });

            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      if (this.$route.query.type == "edit") {
        this.rules.UploadDataId = false;
      }
      //   this.preSave();
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.save();
          // this.saveData();
        } else {
          return false;
        }
      });
    },
    preSave() {
      if (this.$route.query.type == "edit") {
        return utils
          .waitAll([() => this.deleteFile(this.delFileList)])
          .then(() => {
            if (this.fileList.length > 0) {
              this.$refs.uploadFile.submit();
            }
          });
      } else {
        if (this.fileList.length > 0) {
          this.rules.UploadDataId = false;
          this.$refs.uploadFile.submit();
        }
      }
    },
    save() {
      const that = this;
      that.uploadAttch().then(() => {
        // console.log("图片结果")
        // console.log(r)
        that.deleteFile(that.delFileList)
        that.saveData();
      });
    },
    saveData() {
      this.loading = true;
      this.loadingText = "保存中...";
      this.data.Uploader = ZJApp.ZJUser.current.UserName;
      this.data.UploadTime = new Date();
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.DocumentApi()
          .UpdateItem(formAll)
          .then((r) => {
            r = r.data.RspCode;
            this.$message({
              type: "success",
              message: r == "1" ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "典型案例修改";
            this.logInfo.LogMessage = "典型案例修改";
            this.logInfo.ModuleName = "应急档案";
            this.logInfo.PageName = "典型案例详情页";
            this.addOperationLog();
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Id: this.uuid,
          Validity: 1, //新增编辑是1，删除是0
          DocumentTypeId: 1,
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.DocumentApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.RspCode;
            this.$message({
              type: "success",
              message: r == "1" ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "典型案例添加";
            this.logInfo.LogMessage = "典型案例添加";
            this.logInfo.ModuleName = "应急档案";
            this.logInfo.PageName = "典型案例详情页";
            this.addOperationLog();
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    beforeupload: function () {
      this.uploadData.assocID = this.uuid;
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function () {
      // this.data.Extend1 = response.data.FileName || "";
      // this.data.Extend2 = response.data.Extension || "";
      this.loading = false;
      this.rules.UploadDataId = false;
      // this.$refs.File.clearValidate();
      // if (this.$route.query.type == "edit") {
      //   this.updateData();
      // }
    },

    handleRemove(file, fileList) {
      const that = this;
      console.log("fileList", fileList);
      console.log("that.fileList", that.fileList);
      if (file.url) {
        // 最后提交的时候再删除

        that.fileList.forEach((item) => {
          if (item.url == file.url) {
            that.delFileList.push(item.FileID);
            item.Validity = 0;
          }
        });
      }
      let arr = [];
      fileList.forEach((item) => {
        if (that.$route.query.type == "edit") {
          if (!item.url) {
            arr.push(item.raw);
          }
        } else {
          arr.push(item.raw);
        }
      });
      this.uploadFileList = arr;
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    handlePreview(file) {
      console.log(file);
      document.location.href = file.url;
    },
    uploadAttchFile(item) {
      this.uploadFileList.push(item.file);
    },
    // handleChangeFile(file, fileList) {
    //   this.fileList = fileList;
    // },
    deleteFile(FileIDs) {
      return new Apis.FileApi()
        .DeleteFile(FileIDs)
        .then((r) => {
          r = r.data.Data;
          console.debug(r);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //插入附件
    uploadAttch() {
      return new Promise((resolve, reject) => {
        let mediaList = this.uploadFileList;
        var arr = [];
        mediaList.forEach((item) => {
          var option = {
            file: item,
            data: {
              module: "EmergrncyFiles", //模块名
              submodule: "ClassicCase", //子模块
              assocID: this.uuid, //业务ID
              uploader: ZJApp.ZJUser.current.UserName, //上传人
            },
            onProgress: () => {},
            onSuccess: () => {},
            onError: () => {},
          };
          arr.push(this.httpRequest(option));
        });
        utils
          .waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
  },
};
</script>
